import { render, staticRenderFns } from "./ClientApp.vue?vue&type=template&id=04a5e962&"
import script from "./ClientApp.vue?vue&type=script&lang=js&"
export * from "./ClientApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04a5e962')) {
      api.createRecord('04a5e962', component.options)
    } else {
      api.reload('04a5e962', component.options)
    }
    module.hot.accept("./ClientApp.vue?vue&type=template&id=04a5e962&", function () {
      api.rerender('04a5e962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ClientApp.vue"
export default component.exports